module.exports = __webpack_public_path__ + "static/media/Infographie1.b544c36a.jpg";